<template>
  <div class="webmain">
    <Banner/>
    <Enterprise/>
    <Production/>
    <News/>
  </div>
</template>

<script>
import Banner from '../components/main/Banner'
import Enterprise from '../components/main/Enterprise'
import Production from '../components/main/Production'
import News from '../components/main/News'

export default {
  name: 'Main',
  components: {
    Banner,
    Enterprise,
    Production,
    News
  }
}
</script>
<style>

</style>
